export default __webpack_public_path__ + "static/media/caravan.c4e43803.svg";